import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { t } from 'i18next';

/**
 * A functional component that renders a phone number input field.
 */
export const TextFieldPhone = ({ values, handleChange, errors, touched }) => (
    <TextField
        fullWidth
        id="outlined-number"
        label={t('users.fields.phone')}
        type="tel"
        name="phone"
        value={values.phone}
        error={touched.phone && Boolean(errors.phone)}
        helperText={touched.phone && errors.phone}
        onChange={handleChange}
    />
);

TextFieldPhone.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired
};
